export function getView(contract) {
  // show the read-only PDF version if the contract already signed
  return contract.signed_date ? 'Pdf' : 'Html'
}
